export const SYSTOLIC_BLOOD_PRESSURE = 'Systolic';
export const DIASTOLIC_BLOOD_PRESSURE = 'Diastolic';
export const BLOOD_PRESSURE = 'Blood pressure';
export const HEART_RATE = 'Heart rate';

export enum PatientVitalsTabs {
  // @deprecated old version of the tab that is no longer navigable TODO remove
  BLOOD_PRESSURE = 'blood-pressure',
  // @deprecated old version of the tab that is no longer navigable TODO remove
  HEART_RATE = 'heart-rate',
  HEIGHT = 'height',
  WEIGHT = 'weight',
  HEART_RATE_BLOOD_PRESSURE = 'heart-rate_blood-pressure',
}

export enum ObservationCards {
  BLOOD_PRESSURE = 'blood-pressure',
  BMI = 'BMI',
  HEART_RATE = 'heart-rate',
  HEIGHT = 'Height',
  TARGET_WEIGHT = 'target-weight',
  WEIGHT = 'Weight',
}

export enum ObservationStatusType {
  CORRECTED = 'Corrected',
  FINAL = 'Final',
  VOID = 'Void',
}

export type PatientVitalsTabsDefinition = {
  filterBy: string[];
  key: PatientVitalsTabs;
  label: string;
  unit: string | string[];
  isVisible: boolean;
};

export const PatientVitalsTabsCollection: Record<
  PatientVitalsTabs,
  PatientVitalsTabsDefinition
> = {
  [PatientVitalsTabs.WEIGHT]: {
    filterBy: ['Weight'],
    isVisible: true,
    key: PatientVitalsTabs.WEIGHT,
    label: 'Weight',
    unit: 'lbs',
  },
  [PatientVitalsTabs.HEIGHT]: {
    filterBy: ['Height'],
    isVisible: true,
    key: PatientVitalsTabs.HEIGHT,
    label: 'Height',
    unit: 'in',
  },
  [PatientVitalsTabs.BLOOD_PRESSURE]: {
    filterBy: ['Blood pressure'],
    isVisible: false,
    key: PatientVitalsTabs.BLOOD_PRESSURE,
    label: 'Blood pressure',
    unit: 'mmHg',
  },
  [PatientVitalsTabs.HEART_RATE]: {
    filterBy: ['Heart rate'],
    isVisible: false,
    key: PatientVitalsTabs.HEART_RATE,
    label: 'Heart rate',
    unit: 'bpm',
  },
  [PatientVitalsTabs.HEART_RATE_BLOOD_PRESSURE]: {
    filterBy: ['Blood pressure', 'Heart rate'],
    isVisible: true,
    key: PatientVitalsTabs.HEART_RATE_BLOOD_PRESSURE,
    label: 'Heart rate & BP',
    unit: ['mmHg', 'bpm'], // careful while changing these values
  },
};

export const patientVitalsAbnormalInterpretations = ['Low', 'High', 'Abnormal'];
export const patientVitalsNAInterpretation = 'N/A';

export const keyVitalsItemStyles = {
  container: {
    background: 'neutral.background.primary',
    borderColor: 'neutral.line',
    borderRadius: '16px',
    borderWidth: '1px',
    marginBottom: '2px',
    padding: '8px 24px',
  },
  mainGrid: {
    alignItems: 'center',
    gap: '16px',
    minHeight: '52px',
  },
};

export const VITALS_TABS_PADDING = 24;
export const VITALS_TABS_HEIGHT = 42;

export const observationTypeToVitalsTabIndex: Record<ObservationCards, number> =
  {
    [ObservationCards.BLOOD_PRESSURE]: 2,
    [ObservationCards.BMI]: 0,
    [ObservationCards.HEART_RATE]: 2,
    [ObservationCards.HEIGHT]: 1,
    [ObservationCards.TARGET_WEIGHT]: 0,
    [ObservationCards.WEIGHT]: 0,
  };

export enum ObservationHistoryField {
  CREATED = 'created',
  DATETIME = 'observationDatetime',
  INTERPRETATION = 'interpretation',
  NOTE = 'note',
  POSITION = 'position',
  SECONDARY_VALUE = 'secondaryValue',
  STATUS = 'status',
  VALUE = 'value',
}

export type ParsedActivityEvent = {
  activityExternalId: string;
  fieldChanged: ObservationHistoryField;
  newValue: string;
  previousValue?: string;
  type: string;
  updatedAt: string;
  updatedBy: string;
};

export type GridItemProps<T> = {
  colSpan: number;
  id: string;
  isEditing: boolean;
  onChange: (val: T) => void;
  tab?: string;
  value: T;
};
